// extracted by mini-css-extract-plugin
export default {"nav_mobile":"CategoriasNav_nav_mobile__bGqbZ","nav_outer":"CategoriasNav_nav_outer__PEgQE","nav_tab":"CategoriasNav_nav_tab__0PoDC","nav_link":"CategoriasNav_nav_link__I44Vf"};